import React, {useState, useEffect} from 'react';
import menu from './MenuData';
import {Link, useLocation} from 'react-router-dom';

const MenuHeader = ({item}) => {
  return (
    <li className="nk-menu-heading">
      <h6 className="overline-title text-primary">{item}</h6>
    </li>
  );
};

const MenuItem = ({item, headActive, currentPath}) => {
  const {subMenu, text, link, newTab, header, external} = item;
  if (header) {
    return <MenuHeader item={header}></MenuHeader>;
  } 
  
  const isActive = () => {
    if (!link) return false;
    const fullPath = process.env.PUBLIC_URL + link;
    return fullPath === currentPath || (link === '/' && currentPath === process.env.PUBLIC_URL + '/');
  };
  
  return (
    <li
      className={`nk-menu-item ${subMenu ? 'has-sub' : ''} ${
        isActive() ? 'active current-page' : ''
      } ${headActive ? 'active current-page' : ''}`}
    >
        {newTab ? (
          <Link
            className="nk-menu-link"
            target="_blank"
            rel="noopener noreferrer"
            to={`${process.env.PUBLIC_URL + link}`}
          >
            <span className="nk-menu-text">{text}</span>
          </Link>
        ) : subMenu ? (
          <React.Fragment>
            <a
              href="#toggle"
              className="nk-menu-link nk-menu-toggle"
              onClick={(ev) => {
                ev.preventDefault();
              }}
            >
              <span className="nk-menu-text">{text}</span>
            </a>
            <MenuSub subMenu={subMenu} currentPath={currentPath} />
          </React.Fragment>
        ) : external ? (
          <a className="nk-menu-link" href={link}>
            <span className="nk-menu-text">{text}</span>
          </a>
        ) : (
          <Link
            className="nk-menu-link"
            to={process.env.PUBLIC_URL + link}
          >
            <span className="nk-menu-text">{text}</span>
          </Link>
        )}
      </li>
    );
};

const MenuSub = ({subMenu, currentPath}) => {
  return (
    <ul className="nk-menu-sub">
      {subMenu.map((sub, index) => (
        <MenuItem item={sub} key={index} currentPath={currentPath} />
      ))}
    </ul>
  );
};

const checkMenuUrl = (data, currentPath) => {
  for (const node of data.subMenu) {
    const fullPath = process.env.PUBLIC_URL + node.link;
    if (fullPath === currentPath || (node.link === '/' && currentPath === process.env.PUBLIC_URL + '/')) {
      return node;
    } else {
      const newNode = node.subMenu ? checkMenuUrl(node, currentPath) : undefined;
      if (newNode) return newNode;
    }
  }
};

const findActiveHead = (currentPath) => {
  let found;
  menu.forEach((item) => {
    // Check if it's a direct link (like Home)
    if (item.link) {
      const fullPath = process.env.PUBLIC_URL + item.link;
      if (fullPath === currentPath || (item.link === '/' && currentPath === process.env.PUBLIC_URL + '/')) {
        found = item;
        return;
      }
    }
    
    // Check submenus
    if (item.subMenu) {
      let finding = item.subMenu.find((s) => {
        const fullPath = process.env.PUBLIC_URL + s.link;
        return fullPath === currentPath || (s.link === '/' && currentPath === process.env.PUBLIC_URL + '/');
      });
      if (finding) {
        found = item;
      } else {
        item.subMenu.forEach((p) => {
          if (p.subMenu) {
            let finding = checkMenuUrl(p, currentPath);
            if (finding) {
              found = item;
            }
          }
        });
      }
    }
  });
  return found;
};

const Menu = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [head, setHead] = useState('Home');
  let findingActiveHead = findActiveHead(currentPath);

  useEffect(() => {
    if (findingActiveHead) {
      setHead(findingActiveHead.text);
    } else {
      // If no active head found, check if we're on home page
      if (currentPath === process.env.PUBLIC_URL + '/' || currentPath === '/') {
        setHead('Home');
      }
    }
  }, [currentPath, findingActiveHead]);

  return (
    <ul className="nk-menu nk-menu-main ui-s2">
      {menu.map((item, index) => {
        if (item.text === head) {
          return (
            <MenuItem key={index} item={item} headActive={true} currentPath={currentPath} />
          );
        } else return <MenuItem key={index} item={item} currentPath={currentPath} />;
      })}
    </ul>
  );
};

export default Menu;
